e360.factory('eventNotesApi', ['apiHelper', function (apiHelper) {
   return function(eventId) {
      var apiUri = 'events/' + eventId + '/notes';
      return {
         list: function () {
            return apiHelper.get(apiUri);
         },
         update: function (note) {
            return apiHelper.post(apiUri + '/' + note.id, note);
         },
         create: function (note) {
            return apiHelper.post(apiUri, note);
         },
         del: function (id) {
            return apiHelper.del(apiUri + '/' + id);
         }
      };
   };
}]);
